import React from 'react';
import { authService } from '../../services/authService';

export function AccountStatusNotice({ variant }) {
  if (variant === 'pending') {
    return (
      <div className="loading-container">
        <p>
          Your registration is pending admin approval. You'll be able to sign in
          once an administrator approves your account.
        </p>
        <button className="btn-secondary" onClick={() => window.location.reload()}>
          Check again
        </button>
        <button className="btn-primary" onClick={() => authService.logout()}>
          Log out
        </button>
      </div>
    );
  }

  if (variant === 'rejected') {
    return (
      <div className="loading-container">
        <p>
          Your registration was not approved. Please contact an administrator if
          you have questions.
        </p>
        <button className="btn-primary" onClick={() => authService.logout()}>
          Log out
        </button>
      </div>
    );
  }

  return (
    <div className="loading-container">
      <p>Could not load your account. Contact an admin if this persists.</p>
      <button className="btn-secondary" onClick={() => window.location.reload()}>
        Retry
      </button>
      <button className="btn-primary" onClick={() => authService.logout()}>
        Log out
      </button>
    </div>
  );
}
